import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

import { deleteExerciseCategory, fetchExerciseCategories } from '../../../redux/slices/admin/exerciseCategorySlice';

const CategoriesTable = ({ onEdit, handlePageChange }) => {
  const dispatch = useDispatch();
  const { categories, currentCategoryPage, totalCategoryPages } = useSelector((state) => state.exerciseCategories); 
  const [activeDropdown, setActiveDropdown] = useState(null);  

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) { 
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  // Fetch exercises on component mount
  useEffect(() => {
    dispatch(fetchExerciseCategories());
  }, [dispatch]);

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this exercise category?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => dispatch(deleteExerciseCategory(id))
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });    
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Category Name</th>
            <th>Creation Date</th>
            <th className="noprint">Action</th>
          </tr>
        </thead>
        <tbody>
          {categories && categories.length > 0 ? (
            categories.map((category) => (
              <tr key={category.id}>
                <td><div className="text-start">{category.category_name}</div></td>
                <td>{category.creation_date}</td>
                <td className="noprint">
                  <div className="text-center position-relative" ref={dropdownRef}>
                    <button 
                      type="button" 
                      className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots" 
                      aria-expanded="false" 
                      onClick={(e) => toggleDropdown(category.id, e)}
                    >
                      <img src={optionsIcon} alt="Options" />
                    </button>
                    {activeDropdown === category.id && (
                      <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                        <li>
                          <a className="dropdown-item" onClick={() => onEdit(category)}>
                            <img src={editIcon} alt="Edit" /> Edit
                          </a>
                        </li>

                        {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                        <li>
                          <a className="dropdown-item" onClick={() => handleDelete(category.id)}>
                            <img src={deleteIcon} alt="Delete" /> Delete
                          </a>
                        </li>
                        )}

                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center">No categories found.</td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
 
      <Pagination 
        currentPage={currentCategoryPage} 
        totalPages={totalCategoryPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default CategoriesTable;
